import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import PaymentForm from "./PaymentForm.js";

//const PUBLIC_KEY =
//  "pk_test_51O87RqAT8hPoabrJF6IIZ93DvwLqOM1ESwjbJgFcu2SA0byfaVR31E4baXnGCRwHh9TXs2aNhBehG9roYUHXg80J00gySywZ6q";

const PUBLIC_KEY =
  "pk_live_51O87RqAT8hPoabrJpKKAsikRQKmqmLpOzlSzDZpmSATssATsnniLRyQzT2mXnwzHmPH1u9yn7KEUXOuVu5i6cVzm00cA42XXgH";

const stripeTestPromise = loadStripe(PUBLIC_KEY);

export default function StripContainer() {
  return (
    <Elements stripe={stripeTestPromise}>
      <PaymentForm />
    </Elements>
  );
}
